import React from "react";

const Faq: React.FC = () => (
  <section className="faq-section" aria-labelledby="faq-title">
    <div className="container">
      <div className="head">
        <span className="eyebrow">Frequently asked</span>
        <h2 className="section-title" id="faq-title">
          Questions you might be{" "}
          <span className="nobr">
            <em className="hl">pondering</em>.
          </span>
        </h2>
      </div>

      <div className="faq-list">
        <details className="faq-item">
          <summary>How long does this take to finish?</summary>
          <div className="faq-answer">
            <p>
              Around eight hours of content, split into bite-sized lessons of
              roughly 15 minutes each. Most learners finish in around two weeks,
              however, there's no time limit, and you can pause whenever life or
              work gets in the way.
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary>Do I need to have studied this subject before?</summary>
          <div className="faq-answer">
            <p>
              Not at all. We start with the fundamentals and build up. The
              course gives you a fresh way to approach the subject through
              unique insights from some of the world's best thought leaders in
              the field, whether you're brand new to it or a seasoned pro
              looking for a sharper edge.
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary>How does the marking and feedback work?</summary>
          <div className="faq-answer">
            <p>
              Every lesson finishes with a short question to test your
              understanding. Select questions in every course are manually
              marked by us. If something needs a steer, a real person on our
              team comes back with notes that help you get there. If you ever
              get stuck or want to talk something through, we're also always
              happy to hop on a call.
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary>What if I'm not happy with the course?</summary>
          <div className="faq-answer">
            <p>
              You have 30 days from enrolment to ask for a full refund, no
              questions, no exit interview, no awkward email tennis. We reply to
              refund requests within 24 hours, often sooner. If you aren't
              happy, we aren't either.
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary>How is this different from reading the books?</summary>
          <div className="faq-answer">
            <p>
              Books give you the science. This course gives you the application,
              customised around your role and goals so you walk away with
              personalised, practical takeouts for every single lesson.
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary>Will it work in my industry?</summary>
          <div className="faq-answer">
            <p>
              Yes. Past learners have applied it in tech, healthcare, retail,
              banking, government, charities and education. Our AI personalises
              every lesson to your role and goals, so the examples and exercises
              adapt to your context.
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary>Can my employer pay for it?</summary>
          <div className="faq-answer">
            <p>
              Yes. Most learning &amp; development budgets cover this
              comfortably. We can issue a VAT-friendly invoice on request, just
              drop us a line at{" "}
              <a href="mailto:groundcontrol@42courses.com">
                groundcontrol@42courses.com
              </a>
              . For 10 or more learners, see{" "}
              <a href="/team_plans">Team plans</a>.
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary>Is the certificate recognised?</summary>
          <div className="faq-answer">
            <p>
              It's a CPD-accredited certificate, recognised across the UK and
              internationally for continuing professional development.
              Personalised to you with your name, signed, dated and trackable.
              Add it to your LinkedIn profile, your CV, your performance review,
              your fridge.
            </p>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default Faq;
